import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/css/reset.css'
const app = createApp(App)

app.mount('#app')

export default app